import { render, staticRenderFns } from "./Xbcsjkfb.vue?vue&type=template&id=8dcb0da6"
import script from "./Xbcsjkfb.vue?vue&type=script&lang=js"
export * from "./Xbcsjkfb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports